// ============================================================
// SEIKO MODS CUSTOM JS — Injection sur Dawn
// Toutes les fonctions préfixées SeikoMods
// ============================================================

(function() {
  'use strict';

  // ── COLLECTION TABS ──────────────────────────────────────
  function initCollectionTabs() {
    document.querySelectorAll('[data-sm-tabs]').forEach(section => {
      const btns = section.querySelectorAll('.sm-collection-tabs__btn');
      const panels = section.querySelectorAll('.sm-collection-tabs__panel');

      // Activer le premier par défaut
      btns[0]?.classList.add('active');
      panels[0]?.classList.add('active');

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const tabId = btn.dataset.tab;
          btns.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));
          btn.classList.add('active');
          section.querySelector(`[data-panel="${tabId}"]`)?.classList.add('active');
        });
      });
    });
  }

  // ── FAQ ACCORDÉON ─────────────────────────────────────────
  function initFAQ() {
    document.querySelectorAll('.sm-faq__question').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.sm-faq__item');
        const isOpen = item.classList.contains('open');
        // Fermer tous les autres dans le même groupe
        item.closest('.sm-faq__list')
            ?.querySelectorAll('.sm-faq__item.open')
            .forEach(el => el.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  // ── TESTIMONIALS CAROUSEL ─────────────────────────────────
  function initTestimonialsCarousel() {
    document.querySelectorAll('[data-sm-carousel]').forEach(wrapper => {
      const track = wrapper.querySelector('.sm-testimonials__track');
      const cards = track ? [...track.querySelectorAll('.sm-review-card')] : [];
      if (!track || cards.length === 0) return;

      let current = 0;
      let autoplay = null;

      function getVisible() {
        if (window.innerWidth < 600) return 1;
        if (window.innerWidth < 1024) return 2;
        return 3;
      }

      function cardWidth() {
        return (cards[0]?.offsetWidth || 0) + 20;
      }

      function goTo(idx) {
        const max = Math.max(0, cards.length - getVisible());
        current = Math.max(0, Math.min(idx, max));
        track.style.transform = `translateX(-${current * cardWidth()}px)`;
      }

      function startAuto() {
        stopAuto();
        autoplay = setInterval(() => {
          const max = Math.max(0, cards.length - getVisible());
          goTo(current >= max ? 0 : current + 1);
        }, 4500);
      }

      function stopAuto() { clearInterval(autoplay); }

      wrapper.querySelector('[data-sm-carousel-prev]')?.addEventListener('click', () => {
        goTo(current - 1); startAuto();
      });
      wrapper.querySelector('[data-sm-carousel-next]')?.addEventListener('click', () => {
        goTo(current + 1); startAuto();
      });

      // Swipe mobile
      let sx = 0;
      track.addEventListener('touchstart', e => {
        sx = e.touches[0].clientX; stopAuto();
      }, { passive: true });
      track.addEventListener('touchend', e => {
        const dx = sx - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40) dx > 0 ? goTo(current + 1) : goTo(current - 1);
        startAuto();
      });

      window.addEventListener('resize', () => goTo(current));
      startAuto();
    });
  }

  // ── COUNTDOWN TIMER ───────────────────────────────────────
  function initCountdowns() {
    document.querySelectorAll('[data-sm-countdown]').forEach(el => {
      const hours = parseInt(el.dataset.smCountdown) || 24;
      const countdownId = el.dataset.smCountdownId || 'default';
      const storageKey = `sm_countdown_${countdownId}`;

      let endTime = parseInt(localStorage.getItem(storageKey));
      if (!endTime || endTime < Date.now()) {
        endTime = Date.now() + hours * 3600000;
        localStorage.setItem(storageKey, endTime);
      }

      function update() {
        const diff = Math.max(0, endTime - Date.now());
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const pad = n => String(n).padStart(2, '0');
        const hEl = el.querySelector('[data-sm-cd-h]');
        const mEl = el.querySelector('[data-sm-cd-m]');
        const sEl = el.querySelector('[data-sm-cd-s]');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      update();
      setInterval(update, 1000);
    });
  }

  // ── ATC CARD HOVER (best-sellers) ─────────────────────────
  function initCardATC() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.sm-product-card__atc-hover[data-variant-id]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const original = btn.textContent.trim();
      btn.textContent = '...';
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });

        if (!response.ok) throw new Error('Erreur ajout panier');

        // Mettre à jour le compteur cart Dawn
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        // Mise à jour badge cart Dawn (plusieurs sélecteurs possibles selon version)
        document.querySelectorAll('.cart-count-bubble span:first-child, .cart-count-bubble').forEach(el => {
          el.textContent = cart.item_count;
        });

        // Déclencher refresh cart Dawn
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Ouvrir mini-cart Dawn si disponible
        const cartIconBtn = document.querySelector('#cart-icon-bubble');
        if (cartIconBtn && cart.item_count > 0) {
          // Dawn utilise un drawer cart accessible via les events
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        btn.textContent = '✓ Ajouté !';
        btn.style.background = '#22C55E';

        setTimeout(() => {
          btn.textContent = original;
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);
      } catch(err) {
        btn.textContent = 'Erreur !';
        btn.style.background = '#EF4444';
        setTimeout(() => {
          btn.textContent = original;
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);
      }
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initCollectionTabs();
    initFAQ();
    initTestimonialsCarousel();
    initCountdowns();
    initCardATC();
  });

})();

/* ============================================================
   COLLECTION GRID — FINAL CORRECT
   - Card entière cliquable
   - Hover image (CSS natif Dawn + JS fallback)
   - ATC dans .card__information (pas en cercle)
   - Trust injecté 1 seule fois par card
   - Badges % or
   ============================================================ */
(function () {
  'use strict';

  var CFG = {
    urgencyText: 'Dernières pièces',
    maxUrgency: 3,
    urgencyRatio: 0.25,
    atcDefault: 'Ajouter au panier',
    atcLoading: '…',
    atcAdded: '✓ Ajouté !',
    trustText: '↩ 30j remboursé · Garantie 2 ans',
  };

  var urgCount = 0;

  function parsePrice(el) {
    if (!el) return 0;
    return parseFloat(el.textContent.replace(/[^\d,.]/g, '').replace(',', '.')) || 0;
  }

  /* ── 1. CARD ENTIÈRE CLIQUABLE ── */
  function initCardClick() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      if (card._smClick) return;
      card._smClick = true;
      /* Chercher le lien produit dans la card */
      var link = card.querySelector('.card__heading a[href*="/products/"], .full-unstyled-link[href*="/products/"], a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      card.addEventListener('click', function (e) {
        /* Ne pas interférer avec les boutons ou liens natifs */
        if (e.target.closest('.sm-atc-btn')) return;
        if (e.target.tagName === 'A') return;
        if (e.target.tagName === 'BUTTON') return;
        window.location.href = href;
      });
    });
  }

  /* ── 2. BADGES % + URGENCE ── */
  function injectBadges() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      /* Supprimer badges Dawn */
      card.querySelectorAll('.badge, .card__badge, [class*="badge--"]').forEach(function (b) {
        b.style.display = 'none';
      });

      if (card.querySelector('.sm-pct-badge')) return;

      /* Injecter sur .card__inner (position relative déjà assurée par CSS) */
      var target = card.querySelector('.card__inner');
      if (!target) return;

      var saleEl = card.querySelector('.price-item--sale');
      var regEl  = card.querySelector('.price-item--regular');
      var sale   = parsePrice(saleEl);
      var reg    = parsePrice(regEl);

      if (reg > 0 && sale > 0 && reg > sale) {
        var pct = Math.round((reg - sale) / reg * 100);
        if (pct > 0) {
          var b = document.createElement('span');
          b.className = 'sm-pct-badge';
          b.textContent = '-' + pct + '%';
          target.appendChild(b);
        }
      }

      if (urgCount < CFG.maxUrgency && Math.random() < CFG.urgencyRatio) {
        var u = document.createElement('span');
        u.className = 'sm-urgency-badge';
        u.textContent = CFG.urgencyText;
        target.appendChild(u);
        urgCount++;
      }
    });
  }

  /* ── 3. HOVER IMAGE — JS fallback (en plus du CSS Dawn) ── */
  function initHover() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      if (card._smHover) return;
      /* Dawn gère déjà .media--hover-effect via CSS.
         On le force aussi sur mobile (Dawn le cache sur mobile par défaut) */
      var wrap = card.querySelector('.media--hover-effect, .card__media');
      if (!wrap) return;
      var imgs = wrap.querySelectorAll('img');
      if (imgs.length < 2) return;
      card._smHover = true;

      var i1 = imgs[0];
      var i2 = imgs[1];

      /* S'assurer que la 2ème image est en overlay */
      i2.style.position = 'absolute';
      i2.style.inset = '0';
      i2.style.width = '100%';
      i2.style.height = '100%';
      i2.style.objectFit = 'contain';
      i2.style.padding = '8%';
      i2.style.opacity = '0';
      i2.style.transition = 'opacity 0.38s ease';
      i2.style.background = '#FFFFFF';

      wrap.style.position = 'relative';

      card.addEventListener('mouseenter', function () {
        i1.style.opacity = '0';
        i2.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        i1.style.opacity = '1';
        i2.style.opacity = '0';
      });

      /* Touch: swipe pour afficher 2ème image brièvement */
      card.addEventListener('touchstart', function () {
        i1.style.opacity = '0';
        i2.style.opacity = '1';
      }, { passive: true });
      card.addEventListener('touchend', function () {
        setTimeout(function () {
          i1.style.opacity = '1';
          i2.style.opacity = '0';
        }, 1200);
      });
    });
  }

  /* ── 4. BOUTON ATC — appendChild dans .card__information ── */
  function injectATC() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.sm-atc-btn')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href').split('?')[0];

      var btn = document.createElement('button');
      btn.className = 'sm-atc-btn';
      btn.setAttribute('type', 'button');
      btn.textContent = CFG.atcDefault;

      /* Injecter DANS .card__information — pas après, pour éviter le positionnement hors flux */
      var info = card.querySelector('.card__information');
      if (!info) return;
      info.appendChild(btn);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        doATC(btn, href);
      });
    });
  }

  function doATC(btn, href) {
    var orig = btn.textContent;
    btn.textContent = CFG.atcLoading;
    btn.classList.add('sm-atc-btn--loading');
    btn.disabled = true;

    fetch(href + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants.find(function (v) { return v.available; });
        if (!variant) {
          btn.textContent = 'Épuisé';
          btn.style.background = '#9A9090';
          btn.disabled = false;
          return Promise.reject('oos');
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        });
      })
      .then(function (r) { return r && r.json(); })
      .then(function (item) {
        if (!item) return;
        btn.textContent = CFG.atcAdded;
        btn.classList.remove('sm-atc-btn--loading');
        btn.classList.add('sm-atc-btn--added');
        btn.disabled = false;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-item-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
        setTimeout(function () {
          btn.textContent = orig;
          btn.classList.remove('sm-atc-btn--added');
        }, 2500);
      })
      .catch(function (err) {
        if (err === 'oos') return;
        btn.textContent = orig;
        btn.classList.remove('sm-atc-btn--loading');
        btn.disabled = false;
      });
  }

  /* ── 5. TRUST — 1 seule injection par card ── */
  function injectTrust() {
    document.querySelectorAll('.card__information').forEach(function (info) {
      /* Garde stricte : 1 seule fois par .card__information */
      if (info.querySelector('.sm-card-trust')) return;
      var t = document.createElement('span');
      t.className = 'sm-card-trust';
      t.textContent = CFG.trustText;
      /* Insérer avant l'ATC si présent, sinon en fin */
      var atcBtn = info.querySelector('.sm-atc-btn');
      if (atcBtn) {
        info.insertBefore(t, atcBtn);
      } else {
        info.appendChild(t);
      }
    });
  }

  /* ── 6. OBSERVER AJAX (filtres, tri, pagination) ── */
  function observeGrid() {
    var grid = document.querySelector('#product-grid, ul.grid.product-grid');
    if (!grid || grid._smObs) return;
    grid._smObs = true;
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return m.addedNodes.length > 0; })) {
        urgCount = 0;
        setTimeout(run, 200);
      }
    }).observe(grid, { childList: true, subtree: true });
  }

  function run() {
    initCardClick();
    injectBadges();
    initHover();
    injectATC();
    injectTrust();
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    setTimeout(run, 0);
  }
  document.addEventListener('shopify:section:load', function () {
    urgCount = 0;
    run();
  });

})();
